import {createRepository, Repository} from '@/repositories/Base/Repository'

class ExamRepository extends Repository {
    endpoint = 'tuevs/exams'

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }

    fetchSynonyms(id) {
        return this.$axios.get(`tuevs/synonyms/${id}/show`)
    }

    fetchLoincs(id) {
        return this.$axios.get(`tuevs/loincs/${id}/show`)
    }

    bulkPost(params) {
        return this.$axios.post(`tuevs/exams/bulk`, params)
    }

    bulkPut(params) {
        return this.$axios.post(`tuevs/exams/bulk/update`, params)
    }

    findByType(params) {
        return this.$axios.get(`${this.endpoint}/find/by-type`, {params})
    }

    fetchMethods(id) {
        return this.$axios.get(`${this.endpoint}/${id}/methods`)
    }

    fetchPossibleSpecimens(id) {
        return this.$axios.get(`${this.endpoint}/${id}/possible-specimens`)
    }
}

export default new ExamRepository()

export const create = createRepository(ExamRepository)
